<div class="roots-table-card">
<mat-table #sort="matSort" matSort [dataSource]="dataSource" multiTemplateDataRows>

  <!--Primary Table Columns on main Datasource-->
  @for (columnName of tableCols; track columnName; let i = $index) {
    <ng-container matColumnDef="{{columnName}}">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ columnName | columnLabel }}
      </mat-header-cell>
      <mat-cell *matCellDef="let entity" class="roots-cell">
        <span class="mobile-label">{{ columnName | columnLabel }}:</span>
        {{ entity[columnName] }}
      </mat-cell>
    </ng-container>
  }

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <mat-cell *matCellDef="let entity" [attr.colspan]="tableCols.length"
      [@detailExpand]="checkExpanded(entity) ? 'expanded' : 'collapsed'">
      <div class="example-element-detail">
        @if (entity.additionalData) {
          <div class="example-element-description">
            @if (entity.additionalDataIsArray) {
              <div>
                {{entity.additionalData}}
              </div>
            } @else {
              {{entity.additionalData[entity.additionalProperty]}}
            }
          </div>
        } @else {
          <div class="example-element-description">
            @for (item of items; track item) {
              <button mat-button (click)="emitAction(item, entity)">
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.name }}</span>
              </button>
            }
            <!-- No additional entity data -->
          </div>
        }
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="tableCols"></mat-header-row>
  <mat-row *matRowDef="let row; columns: tableCols" matRipple class="example-element-row"
    [class.example-expanded-row]="checkExpanded(row)" (click)="pushPopElement(row)">
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"
  [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'"></mat-row>
</mat-table>

<div class="roots-table-footer">
  <button mat-icon-button class="roots-table-csv" matTooltip="Download CSV" (click)="exportCsv(dataSource.data, csv)">
    <mat-icon>file_download</mat-icon>
  </button>
  <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons>
  </mat-paginator>
</div>
</div>